import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import HideIcon from '@material-ui/icons/VisibilityOff';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import * as actions from '../../../../state';
import { hideBoard } from '../../../../events';
import { ConfirmationAction } from '../../../dialogs';

const messages = defineMessages({
  HIDE: {
    id: 'HIDE',
    defaultMessage: 'Hide',
  },
  HIDE_TOOLTIP: {
    id: 'HIDE_TOOLTIP',
    defaultMessage: 'Hide this board from your board list',
  },
  CONFIRM_HIDE_MSG: {
    id: 'CONFIRM_HIDE_MSG',
    defaultMessage: 'Are you sure you want to hide this board? This action cannot be undone.',
  },
  HIDE_FAILED: {
    id: 'HIDE_FAILED',
    defaultMessage: 'Could not successfully hide this board.',
  },
});

function HideBtn({ intl }) {
  const dispatch = useDispatch();

  const board = useSelector(actions.readStateBoard);

  return (
    <ConfirmationAction
      onConfirm={() => dispatch(hideBoard(board, intl, messages))}
      tooltipMsg={<FormattedMessage {...messages.HIDE_TOOLTIP} />}
      confirmMsg={<FormattedMessage {...messages.CONFIRM_HIDE_MSG} />}
      confirmActionMsg={<FormattedMessage {...messages.HIDE} />}
    >
      <IconButton>
        <HideIcon />
      </IconButton>
    </ConfirmationAction>
  );
}

export default injectIntl(HideBtn);
